import { mittausCacheGet } from '../../../utils/mittausCache';

const GREEN = '#04aa00';
const F = { font: 'Lato', fontSize: 8 };
const TH = { ...F, bold: true, color: '#fff', fillColor: GREEN, alignment: 'center', margin: [0, 2, 0, 2] };
const TD = (opts = {}) => ({ ...F, alignment: 'center', ...opts });

function v(val) { return (val !== null && val !== undefined && val !== '') ? String(val) : '—'; }

const tableLayout = {
  hLineWidth: () => 0.5,
  vLineWidth: () => 0.5,
  hLineColor: () => '#adb5bd',
  vLineColor: () => '#adb5bd',
  paddingLeft:   () => 4,
  paddingRight:  () => 4,
  paddingTop:    () => 3,
  paddingBottom: () => 3,
  fillColor: (row) => row > 0 && row % 2 === 0 ? '#f8f9fa' : null,
};

function blockCaption(blockData, projekt) {
  const raw = blockData?.caption;
  if (!raw) return projekt?.nimi ?? '';
  return (typeof raw === 'string' ? raw : raw.value ?? '').trim() || (projekt?.nimi ?? '');
}

export function renderOhuthieBlock({ block, content, rakennusData, tableCounter }) {
  const blockData = block?.data ?? {};
  const projekt = blockData.mittausProjektiId ? mittausCacheGet(blockData.mittausProjektiId) : null;
  const kohteet = (projekt?.kohteet ?? []).filter(k => (k.data ?? []).length > 0);
  if (!kohteet.length) return;

  const headerRow = [
    { text: 'Tunnus',               ...TH },
    { text: 'Näytteenottokohta',    ...TH },
    { text: 'Laatu-\nluokka',       ...TH },
    { text: 'Kunto-\nluokka',       ...TH },
    { text: 'Pakkas-\nrapautu-\nneisuus', ...TH },
  ];

  const allRows = kohteet.flatMap(k =>
    (Array.isArray(k.data) ? k.data : []).map(row => ({ ...row, _rakenneosa: k.nimi }))
  );
  if (!allRows.length) return;

  const tblNum = tableCounter ? ++tableCounter.value : null;
  const dataRows = allRows.map(row => [
    TD({ text: v(row.tunnus) }),
    TD({ text: v(row._rakenneosa) }),
    TD({ text: v(row.laatuluokka) }),
    TD({ text: v(row.kuntoluokka) }),
    TD({ text: v(row.pakkasrapautuneisuus) }),
  ]);

  content.push({
    stack: [
      {
        table: {
          headerRows: 1,
          widths: ['*', '*', '*', '*', '*'],
          body: [headerRow, ...dataRows],
        },
        layout: tableLayout,
        margin: [0, 5, 0, 0],
      },
      ...(tblNum !== null ? [{
        text: [{ text: `Taulukko ${tblNum}. `, bold: true }, { text: blockCaption(blockData, projekt), bold: false }],
        font: 'Lato', fontSize: 9,
        margin: [0, 4, 0, 0],
      }] : []),
    ],
    margin: [0, 0, 0, 15],
  });
}
